// extracted by mini-css-extract-plugin
export default {"wrapper":"app_wrapper__nE8mJ","main":"app_main__r3s73","wrapper_se2":"app_wrapper_se2__MadIb"};